import Notification from '../../core/Notification';
import CheckDeleteAccountByAdminDialog from './CheckDeleteAccountByAdminDialog';
import DeleteIcon from '@material-ui/icons/Delete';
import GS from '../../grafsync/grafsync';
import AddSubscriptionDialog from '../subscription/AddSubscriptionDialog';
import LabelledSwitch from '../../core/LabelledSwitch';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import AccessibleTooltip from '../AccessibleTooltip';
import Typography from '@material-ui/core/Typography';
import BlockIcon from '@material-ui/icons/Block';
import SupervisedUserIcon from '@material-ui/icons/SupervisedUserCircle';
import MoodIcon from '@material-ui/icons/Mood';
import PropTypes from 'prop-types';
import React from 'react';
import { PACKAGES, MANAGED_MODE } from '../../core/utils/constants';
import BasicReadField from '../BasicReadField';
import UserAvatar from '../users/UserAvatar';
import { globalStyles as styles } from '../style/gstheme';
import TitledPanel from '../TitledPanel';

class UserDetail extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            areYouSure: false,
            hasConverted: false
        };
    }

    convertUserToSSO = () => {
        this.setState({ hasConverted: true }, () => this.props.convertUserToSSO());
    };

    checkIfSure = () => this.setState({ areYouSure: true });

    onSure = async (user) => {
        this.setState({ areYouSure: false });
        try {
            this.props.deleteAccount(user.id);
        }
        catch (e) {
            this.setState({ isErrored: { message: "Cannot delete account. Please try again or contact support." } });
        }
    };

    onNotSure = () => this.setState({ areYouSure: false });

    render() {

        const { user, subscriptions, classes, blockUser, unblockUser, managingUser,
            blocked, changeTrial, hasHadTrial, invitations, addSubscription } = this.props;
        const { areYouSure, hasConverted } = this.state;
        const { username, email } = user;
        const fn = user.familyName || "";
        const gn = user.givenName || "";
        const ssoEnabled = window.Graphologi.sso;
        const nameTitle = user.familyName || user.givenName ? [gn, fn].join(" ") : "No name given";
        const subscriptionOptions = GS.subscriptionOptions();
        const options = subscriptionOptions.filter(subItem => !subItem.free && subItem.billing === "Yearly");

        return (
            <form autoComplete="off">
                <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '13px' }}>
                    <div style={{ display: 'flex' }}>
                        <UserAvatar givenName={gn} familyName={fn} />
                        <Typography
                            data-test="user-detail-name"
                            className={classes.mainHeading}
                            style={{ marginLeft: '10px', marginTop: '3px', ...(blocked === true) && { color: '#DD2C00' } }}>
                            {nameTitle}
                            {user.systemAdmin === true && " (System Administrator)"}
                            {user.superAdmin === true && " (Super Administrator)"}
                        </Typography>
                    </div>
                    {!user.deleted && !user.pendingDeletion &&
                        <div style={{ marginRight: 20, border: 'solid 1px #DD2C00', borderRadius: 4, padding: '6px 12px' }}>
                            {user.systemAdmin !== true && user.superAdmin !== true ?
                                blocked ?
                                    <AccessibleTooltip title='Unblock user' style={{ alignSelf: 'flex-end', marginRight: 20 }}>
                                        <span>
                                            <span style={{ fontSize: 14 }}>Unblock User</span>
                                            <IconButton aria-label="Unblock user" data-test="unblock-user" size="small" onClick={unblockUser} className={classes.deleteButton}>
                                                <MoodIcon />
                                            </IconButton>
                                        </span>
                                    </AccessibleTooltip>
                                    :
                                    <AccessibleTooltip title='Block user' style={{ alignSelf: 'flex-end', marginRight: 20 }}>
                                        <span style={{ whiteSpace: 'nowrap' }}>
                                            <span style={{ fontSize: 14 }}>Block User</span>
                                            <IconButton aria-label="Block user" data-test="block-user" size="small" onClick={blockUser} className={classes.deleteButton} style={{ marginLeft: 6 }}>
                                                <BlockIcon />
                                            </IconButton>
                                        </span>
                                    </AccessibleTooltip>
                                :
                                null
                            }
                            {user.systemAdmin !== true && user.superAdmin !== true ?
                                <AccessibleTooltip title='Permanently delete account' style={{ alignSelf: 'flex-end' }}>
                                    <span style={{ color: '#DD2C00', marginLeft: 24, whiteSpace: 'nowrap' }}>
                                        <span style={{ fontSize: 14 }}>Delete Account</span>
                                        <IconButton aria-label="Delete account" data-test="delete-account" size="small" onClick={this.checkIfSure} className={classes.deleteButton} style={{ marginLeft: 6 }}>
                                            <DeleteIcon style={{ color: '#DD2C00' }} />
                                        </IconButton>
                                    </span>
                                </AccessibleTooltip>
                                :
                                null
                            }
                        </div>
                    }
                </div>
                <div style={{ marginRight: 20, marginBottom: 24 }}>
                    {user.deleted &&
                        <Notification error={true} text="This user has been deleted" dataTest="deleted-notice" />
                    }
                    {user.pendingDeletion &&
                        <Notification error={false} text="This user is pending deletion" dataTest="pending-deletion-notice" />
                    }
                </div>
                {ssoEnabled && !user.ssoUser && user.systemAdmin !== true &&
                    user.superAdmin !== true && !user.pendingDeletion && !user.deleted &&
                    <div style={{ marginRight: 20, marginBottom: 24 }}>
                        <Notification dataTest="non-sso-user" text={
                            <span>
                                {hasConverted ?
                                    <span>User has been converted to SSO. Refresh to see the change.</span>
                                    :
                                    <span>
                                        <span style={{ marginRight: 24 }}>User created by administrator.</span>
                                        <AccessibleTooltip title="Convert to SSO user" className={classes.smallIconButton}>
                                            <IconButton data-test="convert-user"
                                                onClick={this.convertUserToSSO}
                                                size="small">
                                                <SupervisedUserIcon />
                                            </IconButton>
                                        </AccessibleTooltip>
                                    </span>
                                }
                            </span>
                        } />
                    </div>
                }
                {ssoEnabled && user.ssoUser &&
                    <div style={{ marginRight: 20 }}>
                        <Notification dataTest="sso-user" text="User provisioned by SSO." />
                    </div>
                }
                <Grid container spacing={2}>
                    <Grid item xs={12} md={4}>
                        <TitledPanel height="full" title="Username">
                            <BasicReadField ariaLabel="Username" dataTest="username" fullWidth text={username} locked />
                        </TitledPanel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TitledPanel title="Given Name" height="full">
                            <BasicReadField ariaLabel="Give name" dataTest="given-name" fullWidth text={gn} />
                        </TitledPanel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TitledPanel title="Family Name" height="full">
                            <BasicReadField ariaLabel="Family name" dataTest="family-name" fullWidth text={fn} />
                        </TitledPanel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TitledPanel title="Email" height="full">
                            <BasicReadField ariaLabel="Email" dataTest="email" fullWidth text={email || ""} />
                        </TitledPanel>
                    </Grid>
                    <Grid item xs={12} md={8}>
                        <TitledPanel height="full" title="IRI">
                            <BasicReadField ariaLabel="IRI" dataTest="iri" fullWidth text={user.id} />
                        </TitledPanel>
                    </Grid>
                    {window.Graphologi.mode !== MANAGED_MODE && !user.deleted && !user.pendingDeletion &&
                        <Grid item xs={12} md={4}>
                            <TitledPanel title="Has Had Trial" height="full">
                                <LabelledSwitch
                                    disabled={!hasHadTrial}
                                    dataTest="had-trial"
                                    label="Yes"
                                    checked={hasHadTrial}
                                    handleChange={changeTrial}
                                />
                            </TitledPanel>
                        </Grid>
                    }
                    <Grid item xs={12}>
                        <div style={{ paddingTop: 24 }}>
                            {!user.systemAdmin && !user.superAdmin && !blocked && !user.deleted && !user.pendingDeletion &&
                                (managingUser.systemAdmin || window.Graphologi.mode !== MANAGED_MODE ||
                                    window.Graphologi.subControlLevel === 1) &&
                                <AddSubscriptionDialog
                                    buttonTitle="Add Subscription"
                                    options={options}
                                    inverted={true}
                                    systemAdded={true}
                                    subscriptions={subscriptions}
                                    onAddSubscription={addSubscription} />

                            }
                        </div>
                    </Grid>
                    {subscriptions && subscriptions.length > 0 &&
                        <Grid item xs={12}>
                            <TitledPanel dataTest="subscription-list" title="Subscriptions">
                                <div style={{ backgroundColor: 'white' }}>
                                    <Table style={{ maxWidth: '100%' }}>
                                        <TableHead style={{ backgroundColor: '#e8e8e8' }}>
                                            <TableRow>
                                                {
                                                    ["Name", "Approved", "Type", "Package", "IRI"].map((col, index) =>
                                                        <TableCell key={index} component="th" className={classes.tableHeading}>{col}</TableCell>
                                                    )
                                                }
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {subscriptions.map((item, rowIndex) => {
                                                const row = [
                                                    item.subscriptionName,
                                                    item.approved === true ? "Yes" : "No",
                                                    item.subscriptionType,
                                                    PACKAGES[item.subscriptionPackage],
                                                    <span key={rowIndex} style={{ maxWidth: 300 }}>{item.id}</span>
                                                ];
                                                return (
                                                    <TableRow
                                                        data-test={"subscription-detail-" + item.subscriptionName}
                                                        key={"row-" + rowIndex}>
                                                        {row.map((cell, cellIndex) =>
                                                            <TableCell
                                                                data-test={"cell-" + cellIndex}
                                                                key={cellIndex}
                                                                className={classes.tableCell}>
                                                                <Typography className={classes.tableCellText}>{cell}</Typography>
                                                            </TableCell>
                                                        )}
                                                    </TableRow>
                                                );
                                            }
                                            )}
                                        </TableBody>
                                    </Table>
                                </div>
                            </TitledPanel>
                        </Grid>
                    }
                    {invitations && invitations.length > 0 &&
                        <Grid item xs={12}>
                            <TitledPanel dataTest="invitation-list" title="Invited">
                                <div style={{ backgroundColor: 'white' }}>
                                    <Table style={{ maxWidth: '100%' }}>
                                        <TableHead style={{ backgroundColor: '#e8e8e8' }}>
                                            <TableRow>
                                                {
                                                    ["Name", "Subscription IRI"].map((col, index) =>
                                                        <TableCell key={index} component="th" className={classes.tableHeading}>{col}</TableCell>
                                                    )
                                                }
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {invitations.map((item, rowIndex) => {
                                                const row = [
                                                    item.subscriptionName,
                                                    <span key={rowIndex} style={{ maxWidth: 300 }}>{item.subscription}</span>
                                                ];
                                                return (
                                                    <TableRow
                                                        data-test={"invitation-detail-" + item.subscriptionName}
                                                        key={"row-" + rowIndex}>
                                                        {row.map((cell, cellIndex) =>
                                                            <TableCell
                                                                data-test={"cell-" + cellIndex}
                                                                key={cellIndex}
                                                                className={classes.tableCell}>
                                                                <Typography className={classes.tableCellText}>{cell}</Typography>
                                                            </TableCell>
                                                        )}
                                                    </TableRow>
                                                );
                                            }
                                            )}
                                        </TableBody>
                                    </Table>
                                </div>
                            </TitledPanel>
                        </Grid>
                    }
                </Grid>
                {areYouSure && <CheckDeleteAccountByAdminDialog onSure={() => this.onSure(user)} onNotSure={this.onNotSure} />}
            </form>
        );
    }
}

UserDetail.defaultProps = {
    hasHadTrial: false
};

UserDetail.propTypes = {
    classes: PropTypes.object,
    user: PropTypes.object.isRequired,
    managingUser: PropTypes.object,
    hasHadTrial: PropTypes.bool,
    subscriptions: PropTypes.array,
    invitations: PropTypes.array,
    addSubscription: PropTypes.func.isRequired,
    blockUser: PropTypes.func.isRequired,
    blocked: PropTypes.bool.isRequired,
    changeTrial: PropTypes.func.isRequired,
    convertUserToSSO: PropTypes.func.isRequired,
    unblockUser: PropTypes.func.isRequired,
    deleteAccount: PropTypes.func.isRequired
};

export default withStyles(styles)(UserDetail);